import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { AuthenticationService } from '../services/auth.service';

import { environment } from '../../../environments/environment';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthenticationService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

            // N'attache l'auth qu'aux appels vers notre API — les APIs externes
            // (ex: Open-Meteo) refusent le preflight CORS déclenché par ces headers.
            if (request.url.startsWith('http') && !request.url.startsWith(environment.BASE_URL)) {
                return next.handle(request);
            }

            const currentUser = this.authenticationService.currentUser();
            if (!currentUser) {
                return next.handle(request);
            }

            // Jeton renouvelé par le SDK Firebase. Pas de repli sur l'instantané de session :
            // périmé après 1 h, il provoquait un 401 donc une déconnexion forcée. Si le
            // renouvellement échoue (réseau), la requête échoue simplement et peut être relancée.
            return from(this.authenticationService.getIdToken()).pipe(
                switchMap(token => {
                    if (!token) {
                        return next.handle(request);
                    }
                    return next.handle(request.clone({
                        setHeaders: {
                            'Authorization': `Bearer ${token}`,
                            'x-tenant': currentUser.tenant || '',
                        }
                    }));
                })
            );
    }
}
